<div class="overflow-x-auto">
  <table>
    <thead>
      <tr>
        <th>
          <div class="permission-types-header" i18n>Permission Types</div>
        </th>
        <th>
          <div class="d-flex flex-column gap-3 justify-content-end align-items-center">
            <ng-container *ngIf="formArray.enabled">
              <div class="permission-label" [style.line-height.rem]="1.5" i18n>Select All</div>
              <div>
                <app-indeterminate-checkbox
                  [state]="selectAllState()"
                  [disabled]="formArray.disabled"
                  (checkboxClicked)="onSelectAllClicked()" />
              </div>
            </ng-container>
          </div>
        </th>
        <ng-container *ngFor="let type of submissionPermissionTypes">
          <th>
            <div class="d-flex flex-column gap-3 align-items-center justify-content-end">
              <div
                [ngbTooltip]="type.tooltipText"
                class="d-flex gap-1 align-items-center overflow-x-visible cursor-pointer"
                [style.max-width.rem]="6.125">
                <img class="cursor-pointer" [style.height.rem]="1.5" [style.width.rem]="1.5" [src]="type.icon" alt="" />
                <div class="permission-label text-nowrap" [class.disabled]="formArray.disabled" i18n>
                  {{ type.name }}
                </div>
              </div>
              <app-indeterminate-checkbox
                *ngIf="formArray.enabled"
                [state]="selectAllOfTypeState(type.id)"
                [disabled]="formArray.disabled"
                (checkboxClicked)="onSelectAllOfTypeClicked(type.id)" />
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let type of formArray.controls">
        <tr>
          <td colspan="2">
            <div class="permission-label">{{ type.controls.name.value }}</div>
          </td>
          <ng-container *ngFor="let permission of type.controls.submissionPermissions.controls">
            <td [formGroup]="permission">
              <div class="d-flex justify-content-center">
                <app-checkbox-input
                  *ngIf="!(permanentlyDisabledIds | includes : permission.controls.id.value)"
                  formControlName="hasPermission"
                  (checkboxClicked)="onPermissionChange(permission, type)" />
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
